declare var swal: any;
import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbSpecimenCollection } from './specimencollection.modal';
import { NgbResult } from './results.modal';
import { NgbSign } from './sign.modal';
import { ApiResponseModel } from '../../models/api_response_model';
import { AppData } from '../../models/appdata';
import { LabOrdersListController, LabOrdersListRequest, OrderTestDataByCodeController, OrderTestDataByCodeRequest } from '../../models/actor/actor';
import { PrintService } from '../../services/print.service';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../services/spinner.service';
import { ActorService } from '../../services/actor.service';
import { HCPService } from '../../services/hcp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FDService } from '../../services/fd.service';
import { NGXToastrService } from '../../../../../src/app/shared/services/toastr.service';
import * as alertFunctions from '../../../shared/data/sweet-alerts';


@Component({
  selector: 'app-lab',
  templateUrl: './lab.component.html',
  styleUrls: ['./lab.component.css']
})
export class LabComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  TodayDate = new Date();

  constructor(private modalService: NgbModal,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter) { }

  CurrentLabOrdersListController: LabOrdersListController[];
  CurrentLabOrdersListRequest: LabOrdersListRequest;

  LoadOrders() {
    this.CurrentLabOrdersListRequest = new LabOrdersListRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentLabOrdersListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetLabOrdersListController();
  }

  GetLabOrdersListController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.CurrentLabOrdersListRequest.ConditionalOperator = 1;
    this.CurrentLabOrdersListRequest.EffectiveOrderDate = new Date('2016-05-02');
    this.CurrentLabOrdersListRequest.LabCode = 10;
    this.CurrentLabOrdersListRequest.OrderTestCode = 10044;
    this.CurrentLabOrdersListRequest.PatientRegNumber = "GG1I/1396";
    this.CurrentLabOrdersListRequest.TestCode = 10;
    //alert(this.FormattedCode);
    this.actorservice.GetLabOrdersListController(this.CurrentLabOrdersListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentLabOrdersListController = this.ApiResData.Result;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentOrderTestDataByCodeController: OrderTestDataByCodeController[];
  CurrentOrderTestDataByCodeRequest: OrderTestDataByCodeRequest;

  LoadOrderTest() {
    this.CurrentOrderTestDataByCodeRequest = new OrderTestDataByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentOrderTestDataByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOrderTestDataByCodeController();
  }

  GetOrderTestDataByCodeController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.CurrentOrderTestDataByCodeRequest.ConditionalOperator = 10;
    this.CurrentOrderTestDataByCodeRequest.OrderTestCode = 86807;
    //this.CurrentOrderTestDataByCodeRequest.isUnsignEdit = false;
    this.actorservice.GetOrderTestDataByCodeController(this.CurrentOrderTestDataByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentOrderTestDataByCodeController = this.ApiResData.Result;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  ngOnInit() {
    this.LoadOrders();
    this.LoadOrderTest();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

  }

  SpecimenDetails() {
    const modalRef = this.modalService.open(NgbSpecimenCollection,
      {
        centered: true,
        size: "lg"

      })
  }
  ResultDetails() {
    const modalRef = this.modalService.open(NgbResult,
      {
        centered: true,
        size: "lg"

      })
  }
  SignDetails() {
    const modalRef = this.modalService.open(NgbSign,
      {
        centered: true,
        size: "lg"

      })
  }
  dataChanged(newobj) {

    this._GetLabOrdersListController()
  }
  _GetLabOrdersListController() {
    this.StartRefreshing();

    this.CurrentLabOrdersListRequest.ConditionalOperator = 1;
    this.CurrentLabOrdersListRequest.LabCode = 10;
    this.CurrentLabOrdersListRequest.OrderTestCode = 10044;
    this.CurrentLabOrdersListRequest.PatientRegNumber = "GG1I/1396";
    this.CurrentLabOrdersListRequest.TestCode = 10;
    //this.CurrentLabOrdersListRequest.EffectiveOrderDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentLabOrdersListRequest.EffectiveOrderDate = new Date('2016-05-02');
    //this.CurrentLabOrdersListRequest.LabCode = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //alert(this.FormattedCode);
    this.actorservice.GetLabOrdersListController(this.CurrentLabOrdersListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentLabOrdersListController = this.ApiResData.Result;
          //this.pdata = this.CurrentFollicularScansBetweenDateController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetLabOrdersListController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetLabOrdersListController();
    //ind++;
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
